<template>
    <div style="clear: both;">商品详情：{{ id }}</div>
</template>

<script>
    export default {
        name: "topic_detail",
        components: {},
        data: () => {
            return {
                id: 0
            }
        },
        created() {
            console.log('topic_detail',this.$route.query);
            this.id = this.$route.path.replace("/promotion/topic-goods-", "")
        },
        methods: {}
    }
</script>
<style lang="scss" scoped></style>
